import React, { useState, useRef } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from 'react-bootstrap';
import { secondsToTime } from '../../utilities/scoringUtilities';
import scoringService from '../../services/ScoringService';
import { v4 as uuidv4 } from 'uuid';

const PenaltyShotAtGoal = (props) => {

    const { homeTeam, awayTeam, fixtureRoomId, startTeamId, homeTeamPlayers, awayTeamPlayers, realMarkerX, realMarkerY, videoTime, clipStartTime, half, setShowMultipleSelectedButton, onCancelButtonClick } = props;

    const dropdownSelectPlayerRef = useRef(null);

    const [scoreErrorMessages, setScoreErrorMessages] = useState(null);
    const [errorInputIds, setErrorInputIds] = useState(null);
    const [selectedPlayer, setSelectedPlayer] = useState(undefined);
    const [selectedScore, setSelectedScore] = useState(undefined);
    const [missedPenaltyInPlay, setMissedPenaltyInPlay] = useState(false);

    const handleSuccessfulPenalty = async () => {
        if (selectedPlayer == null){
            setScoreErrorMessages([{ id: uuidv4(), text: "Please select a player" }]);
        } else {
            if (videoTime <= clipStartTime) {
                setScoreErrorMessages([{ id: uuidv4(), text: "Penalty result must come after Penalty awarded" }]);
            } else {
                await scoringService.addPenaltyKick(fixtureRoomId, startTeamId, clipStartTime, videoTime, 3, realMarkerX, realMarkerY, selectedPlayer, 1, [{ key: 41, value: 1 }], half, true, false);
                setShowMultipleSelectedButton(true);
            }
    }}

    const handleUnsuccessfulPenalty = async () => {
        if (selectedPlayer == null){
            setScoreErrorMessages([{ id: uuidv4(), text: "Please select a player" }]);
        } else {
            if (videoTime <= clipStartTime) {
                setScoreErrorMessages([{ id: uuidv4(), text: "Penalty result must come after Penalty awarded" }]);
            } else {
                await scoringService.addPenaltyKick(fixtureRoomId, startTeamId, clipStartTime, videoTime, 3, realMarkerX, realMarkerY, selectedPlayer, -1, [{ key: 41, value: 1 }], half, false, false);
                setShowMultipleSelectedButton(true);
            }
    }}

    const handleUnsuccessfulPenaltyInPlay = async () => {
        if (realMarkerX == null || realMarkerY == null){
            setScoreErrorMessages([{ id: uuidv4(), text: "Please set penalty kick coordinates" }]);
        } else {
            if (videoTime <= clipStartTime) {
                setScoreErrorMessages([{ id: uuidv4(), text: "Penalty result must come after Penalty awarded" }]);
            } else {
                if (selectedPlayer == null) {
                    setScoreErrorMessages([{ id: uuidv4(), text: "Please select a player" }]);
                } else if (selectedScore == null) {
                    setScoreErrorMessages([{ id: uuidv4(), text: "Please select a score" }]);
                } else {
                    await scoringService.addPenaltyKick(fixtureRoomId, startTeamId, clipStartTime, videoTime, 3, realMarkerX, realMarkerY, selectedPlayer, selectedScore, [{ key: 41, value: 1 }], half, false, true);
                    setShowMultipleSelectedButton(true);
            }}
    }}

    const getScoreErrorMessageSpan = () => {
        if (scoreErrorMessages && scoreErrorMessages.length > 0) {

            let result = [];

            for (let i = 0; i < scoreErrorMessages.length; i++) {
                let current = scoreErrorMessages[i];
                result.push(
                    <Alert key={current.id} variant="danger" className="text-center my-1" onClose={() => {
                        setScoreErrorMessages(scoreErrorMessages && scoreErrorMessages.length > 0 ? scoreErrorMessages.filter((x) => x.id != current.id) : null);
                        setErrorInputIds(errorInputIds && errorInputIds.length > 0 ? errorInputIds.filter((x) => x != current.id) : null);
                    }} dismissible>
                        <span>{current.text}</span>
                    </Alert>);
            }

            return <div className="mb-1" style={{ maxHeight: '240px', overflowY: 'scroll' }}>{result}</div>;
        }
    }

    const scoreErrorMessageSpan = getScoreErrorMessageSpan();

    return <>

        <div className="col-md-12 text-center">
                    <h3>Penalty Shot at Goal</h3>
            
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Team: &nbsp; </b></span>
                        <span className="py-1">{startTeamId == homeTeam.id ? homeTeam.name : awayTeam.name }</span>
                    </div>
                </Col>
            </Row>
            <Row className="pt-2">
                <Col>
                    <div className="d-flex">
                        <span className="py-1"><b>Select Penalty Kicker:</b></span>
                        <Form.Control as="select"
                            size="sm"
                            ref={dropdownSelectPlayerRef}
                            value={selectedPlayer} 
                            onChange={(event) => { setSelectedPlayer(event.target.value) }}
                            className="ml-1"
                            style={{ width: '175px' }}
                        >
                            <option key={1}>Please select kicker...</option>   
                            {startTeamId == homeTeam.id ?
                                homeTeamPlayers && homeTeamPlayers.map(x => {
                                    return <option key={x.position} value={x.shirtNumber}>{x.key}</option>})
                                : 
                                awayTeamPlayers && awayTeamPlayers.map(x => {
                                    return <option key={x.position} value={x.shirtNumber}>{x.key}</option>})
                            }
                        </Form.Control>
                        </div>
                    </Col>
            </Row>
            
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Category: &nbsp; </b></span>
                            <span className="py-1">Place Kick</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Location: &nbsp; </b></span>
                            <span className="py-1">x: {Math.round(realMarkerX)}m y: {Math.round(realMarkerY)}m</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Penalty awarded at: &nbsp; </b></span>
                        <span className="py-1">{secondsToTime(clipStartTime)}</span>
                    </div>
                </Col>
            </Row>
            <div style={{
                height: '45px'
            }}>
            {missedPenaltyInPlay == false &&
            <Row>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="danger"
                            onClick={async (e) => {
                                await onCancelButtonClick(e);
                            }}>Cancel</Button>
                    </div>
                </Col>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="danger" 
                        onClick={async () => {
                            await handleUnsuccessfulPenalty(realMarkerX, realMarkerY);
                            }}>Missed Penalty</Button>
                    </div>
                </Col>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="success" 
                        onClick={async () => {
                            await handleSuccessfulPenalty(realMarkerX, realMarkerY);
                            }}>Successful Penalty</Button>
                    </div>
                </Col>
                </Row>}
                </div>
            <Row><p> </p></Row>
            <Row>
                <div className="col-md-12 text-right">
                    <Button className="col-md-12 text-center" 
                    variant="outline-danger"
                    onClick={async () => {
                        await setMissedPenaltyInPlay(true);
                        }}>Missed Penalty (Remained in play)</Button>
                </div>
            </Row>
            {missedPenaltyInPlay == true &&
            <div>
            <Row className="pt-2">
                <Col>
                    <div className="d-flex">
                        <span className="py-1"><b>Select Player Score:</b></span>
                        <Form.Control as="select"
                            size="sm"
                            //ref={dropdownSelectPlayerRef}
                            value={selectedScore}
                            onChange={(event, value) => setSelectedScore(event.target.value)}
                            className="ml-1"
                            style={{ width: '175px' }}>   
                            <option key={11}>Please select score...</option>   
                            <option key={0} value={0}>0</option>
                            <option key={1} value={-0.125}>-0.125</option>
                            <option key={2} value={-0.25}>-0.25</option>
                            <option key={3} value={-0.5}>-0.5</option>
                            <option key={4} value={-1}>-1</option>
                            <option key={5} value={-1.5}>-1.5</option>
                            <option key={6} value={-2}>-2</option>
                            <option key={7} value={-2.5}>-2.5</option>
                            <option key={8} value={-3}>-3</option>
                            <option key={9} value={-3.5}>-3.5</option>
                            <option key={10} value={-4}>-4</option>
                        </Form.Control>
                        </div>
                    </Col>
            </Row>
            <Row><p></p></Row>
            <Row>
            <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="danger"
                        onClick={async () => {
                            await setMissedPenaltyInPlay(false);
                            }}>Cancel</Button>
                    </div>
                </Col>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="success" 
                        onClick={async () => {
                            await handleUnsuccessfulPenaltyInPlay(realMarkerX, realMarkerY);
                            }}>Submit</Button>
                    </div>
                </Col>
            </Row>
            </div>}
            </div> 
            

            {scoreErrorMessageSpan}
    </>;
}

export default PenaltyShotAtGoal;